import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMD = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M35.87 2.48A24.901 24.901 0 0 0 25 0c-3.896 0-7.583.891-10.87 2.48L11.956 25l2.174 22.52A24.901 24.901 0 0 0 25 50a24.9 24.9 0 0 0 10.87-2.48L38.042 25 35.87 2.48Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M14.13 2.481C5.768 6.525 0 15.088 0 25c0 9.911 5.768 18.474 14.13 22.518V2.481Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M35.869 2.481v45.037c8.362-4.044 14.13-12.607 14.13-22.518 0-9.912-5.768-18.475-14.13-22.519Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M33.696 19.67h-5.979a2.717 2.717 0 1 0-5.434 0h-5.979c0 1.478 1.288 2.676 2.765 2.676h-.09a2.676 2.676 0 0 0 2.677 2.675c0 1.309.94 2.396 2.18 2.628l-2.108 4.76c1.01.41 2.114.64 3.272.64a8.668 8.668 0 0 0 3.272-.64l-2.108-4.76a2.675 2.675 0 0 0 2.18-2.628 2.676 2.676 0 0 0 2.676-2.675h-.09c1.478 0 2.766-1.198 2.766-2.676Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 23.37 21.467 25v3.262L25 30.434l3.532-2.173V25L25 23.37Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M21.467 21.738h7.065V25h-7.065v-3.26Z"
}));
FlagMD.displayName = 'FlagMD';
export default withFlagWrapper(FlagMD);
//# sourceMappingURL=index.js.map